import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import ReactTooltip from 'react-tooltip'
import { connect } from 'react-redux'
import Masonry from 'react-masonry-component'
import AnalysisCard from 'wt-react/dist/components/AnalysisCard/AnalysisCard'
// import AnalysisCard from '../AnalysisCard/AnalysisCard.js';
import { KEY_METRICS } from './StrategyList.js'
import { formatDate, formatPercent, getKeyMetrics, getKeyMetricsSymbols, getKeyMetricsClicks } from '../../../common'
import i18n from './../../../i18n'
import './StrategyAnalysis.css'
import { zip } from 'underscore'

const COLORS = {
  blue: '#0047BB',
  teal: '#05A9B1',
  grey: '#5B6770',
  orange: '#F68D2E',
  auburn: '#84344E',
  sky: '#00A9E0',
  green: '#658D1B',
  white: '#FFFFFF',
  silver: '#BDC2C6',
  navy: '#050139'
}

class StrategyAnalysis extends PureComponent {
  constructor(props) {
    super(props)

    this.state = {
      cardHovered: null
    }
  }

  // Handle a hover over a card
  setCardHovered() {
    setTimeout(() => {
      // this.masonry.reloadItems();
      this.masonry.layout()
    }, 200)
  }

  renderKeyMetrics() {
    const personalStrategy = this.props.personalStrategy

    if (personalStrategy.latestAnalysis && personalStrategy.latestAnalysis.statistics) {
      const metricsValues = getKeyMetrics(personalStrategy.latestAnalysis.statistics)
      const metricsSymbols = getKeyMetricsSymbols()
      const metricClicks = getKeyMetricsClicks()

      // Build metric data and labels
      const metricData = KEY_METRICS.map(metric => {
        return {
          name: metric,
          title: i18n.t(metric),
          tooltip: i18n
            .t(metric + '-tooltip')
            .replace('[[FROM]]', formatDate(personalStrategy.latestAnalysis.commonPeriodStart))
            .replace('[[TO]]', formatDate(personalStrategy.latestAnalysis.commonPeriodEnd))
            .replace('[[ASOF]]', formatDate(personalStrategy.latestAnalysis.commonPeriodEnd)),
          description: i18n.t(metric + '-desc'),
          value: metricsValues[metric],
          symbol: metricsSymbols[metric],
          clickable: metricClicks[metric]
        }
      })
      return (
        <div className='pscard' key={'keymetrics' + personalStrategy.id} onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
          <AnalysisCard idOfCard='key-metrics' topOfAppId='personal-strategy-top-of-app' key={'keymetrics-card' + personalStrategy.id} chartType='keymetrics' cardTitle={i18n.t('key-metrics-title')} seriesData={metricData} footnoteText={i18n.t('key-metrics-footnote')} showDetailsOnHover={false} />
        </div>
      )
    } else {
      return null
    }
  }

  renderFundStdPerformance() {
    const personalStrategy = this.props.personalStrategy

    if (personalStrategy.latestAnalysis && Array.isArray(personalStrategy.latestAnalysis.holdings)) {
      return (
        <div className='pscard pscard--width2' key={'fundstdperformance' + personalStrategy.id} onClick={() => this.setCardHovered()} onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
          <AnalysisCard idOfCard='performance-chart' topOfAppId='personal-strategy-top-of-app' key={'fundstdperformance-card' + personalStrategy.id} chartType='performancetable' cardTitle={i18n.t('fundstdperformance-title')} personalStrategy={personalStrategy} footnoteText={i18n.t('fundstdperformance-footnote')} translationDictionary={i18n} showDetailsOnHover={false} />
        </div>
      )
    } else {
      return null
    }
  }

  renderPerformanceChart() {
    const personalStrategy = this.props.personalStrategy

    // Add Performance Strategy data
    let seriesData = [
      {
        data: personalStrategy.latestAnalysis.levels.uv1MNAV,
        name: personalStrategy.name,
        color: COLORS.blue
      }
    ]

    // If a benchmark exists then add to the portfolio performance
    if (personalStrategy.latestAnalysis.benchmarks && personalStrategy.latestAnalysis.benchmarks.length > 0) {
      seriesData.push({
        data: personalStrategy.latestAnalysis.benchmarks[0].levels.uv1MNAV,
        name: personalStrategy.latestAnalysis.benchmarks[0].name,
        color: COLORS.silver
      })
    }

    return personalStrategy !== null && personalStrategy.latestAnalysis !== null ? (
      <div className='pscard' onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
        <AnalysisCard
          idOfCard='growth-1m'
          topOfAppId='personal-strategy-top-of-app'
          key='performance'
          chartType='line'
          cardTitle={i18n.t('growth')}
          showChartLabels={true}
          seriesCurrencyLabel='$'
          showLegend={false}
          categoryData={personalStrategy.latestAnalysis.levels.date}
          categoryIsDate={true}
          seriesData={seriesData}
          showGrid={true}
          showAxes={true}
          heroTitle={i18n.t('hypothetical-growth-title').replace('[[FROM]]', formatDate(personalStrategy.latestAnalysis.commonPeriodStart)).replace('[[TO]]', formatDate(personalStrategy.latestAnalysis.commonPeriodEnd))}
          // Keep the other hero titles in case we need for dashboard
          // chartTitle={i18n.t('hypothetical-growth-title')
          //     .replace('[[FROM]]', formatDate(personalStrategy.latestAnalysis.commonPeriodStart))
          //     .replace('[[TO]]', formatDate(personalStrategy.latestAnalysis.commonPeriodEnd))}
          // heroNumber={personalStrategy.latestAnalysis.statistics.avgAnnualPerformance}
          // heroTitle={i18n.t('common-period-total-return')
          //     .replace('[[FROM]]', formatDate(personalStrategy.latestAnalysis.commonPeriodStart))
          //     .replace('[[TO]]', formatDate(personalStrategy.latestAnalysis.commonPeriodEnd))}
          footnoteText={i18n.t('hypothetical-growth-footnote')}
        />
      </div>
    ) : null
  }

  renderIncomeChart() {
    const personalStrategy = this.props.personalStrategy

    return personalStrategy !== null && personalStrategy.latestAnalysis !== null ? (
      <div className='pscard' onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
        <AnalysisCard
          idOfCard='income-chart'
          topOfAppId='personal-strategy-top-of-app'
          key='income'
          chartType='column'
          cardTitle={i18n.t('income')}
          showChartLabels={true}
          heroTitle={i18n.t('calendar-year-income-title')}
          showLegend={false}
          categoryData={personalStrategy.latestAnalysis.aggregateDistributions.calendarYear}
          categoryIsDate={false}
          seriesIsPercentage={false}
          seriesData={personalStrategy.latestAnalysis.aggregateDistributions.ordinaryIncome}
          seriesCurrencyLabel='$'
          showGrid={true}
          showAxes={true}
          // heroNumber={personalStrategy.latestAnalysis.statistics.dividendYield}
          // heroTitle={i18n.t('income-desc') + '. ' + i18n.t('income-tooltip')
          //     .replace('[[ASOF]]', formatDate(personalStrategy.latestAnalysis.commonPeriodEnd))}
          footnoteText={i18n.t('calendar-year-income-footnote')}
          showDetailsOnHover={false}
          seriesColor={COLORS.navy}
        />
      </div>
    ) : null
  }

  renderSectorChart() {
    const personalStrategy = this.props.personalStrategy

    // Add Sector data
    let seriesData = [
      {
        data: personalStrategy.latestAnalysis.sectorExposures[0].values,
        categories: personalStrategy.latestAnalysis.sectorExposures[0].keys,
        name: personalStrategy.name,
        color: COLORS.blue
      }
    ]

    // If a benchmark exists then add to the data
    if (personalStrategy.latestAnalysis.benchmarks && personalStrategy.latestAnalysis.benchmarks.length > 0) {
      seriesData.push({
        data: personalStrategy.latestAnalysis.benchmarks[0].sectorExposures[0].values,
        categories: personalStrategy.latestAnalysis.benchmarks[0].sectorExposures[0].keys,
        name: personalStrategy.latestAnalysis.benchmarks[0].name,
        color: COLORS.silver
      })
    }

    return personalStrategy !== null && personalStrategy.latestAnalysis !== null && personalStrategy.latestAnalysis.sectorExposures !== null ? (
      <div className='pscard' onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
        <AnalysisCard idOfCard='sector-exposures' topOfAppId='personal-strategy-top-of-app' key='sector' chartType='bar' cardTitle={i18n.t('sectors')} showChartLabels={true} heroTitle={i18n.t('sector-exposures-title')} showLegend={false} categoryIsDate={false} seriesData={seriesData} showGrid={true} showAxes={true} footnoteText={i18n.t('sector-exposures-footnote').replace('[[ASOF]]', formatDate(personalStrategy.latestAnalysis.sectorExposures[0].date))} showDetailsOnHover={false} seriesColor={COLORS.blue} seriesIsPercentage={true} />
      </div>
    ) : null
  }

  renderGeographyChart() {
    const personalStrategy = this.props.personalStrategy

    // Add Country data
    let seriesData = [
      {
        data: personalStrategy.latestAnalysis.countryExposures[0].values,
        categories: personalStrategy.latestAnalysis.countryExposures[0].keys,
        name: personalStrategy.name,
        color: COLORS.blue
      }
    ]

    // If a benchmark exists then add to the data
    if (personalStrategy.latestAnalysis.benchmarks && personalStrategy.latestAnalysis.benchmarks.length > 0) {
      seriesData.push({
        data: personalStrategy.latestAnalysis.benchmarks[0].countryExposures[0].values,
        categories: personalStrategy.latestAnalysis.benchmarks[0].countryExposures[0].keys,
        name: personalStrategy.latestAnalysis.benchmarks[0].name,
        color: COLORS.silver
      })
    }

    return personalStrategy !== null && personalStrategy.latestAnalysis !== null && personalStrategy.latestAnalysis.countryExposures !== null ? (
      <div className='pscard' onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
        <AnalysisCard idOfCard='geography-exposures' topOfAppId='personal-strategy-top-of-app' key='geography' chartType='bar' cardTitle={i18n.t('geographies')} showChartLabels={true} heroTitle={i18n.t('geography-exposures-title')} categoryIsDate={false} seriesData={seriesData} showGrid={true} showAxes={true} footnoteText={i18n.t('geography-exposures-footnote').replace('[[ASOF]]', formatDate(personalStrategy.latestAnalysis.countryExposures[0].date))} showDetailsOnHover={false} seriesIsPercentage={true} sliceCategoriesToN={10} />
      </div>
    ) : null
  }

  renderMarketCapChart() {
    const personalStrategy = this.props.personalStrategy

    // Add Market cap data
    let seriesData = [
      {
        data: personalStrategy.latestAnalysis.marketCapExposures[0].values,
        categories: personalStrategy.latestAnalysis.marketCapExposures[0].keys.map(key => {
          return key.replace('midCap', i18n.t('mid-cap')).replace('largeCap', i18n.t('large-cap')).replace('smallCap', i18n.t('small-cap'))
        }),
        name: personalStrategy.name,
        color: COLORS.blue
      }
    ]

    // If a benchmark exists then add to the data
    if (personalStrategy.latestAnalysis.benchmarks && personalStrategy.latestAnalysis.benchmarks.length > 0) {
      seriesData.push({
        data: personalStrategy.latestAnalysis.benchmarks[0].marketCapExposures[0].values,
        categories: personalStrategy.latestAnalysis.benchmarks[0].marketCapExposures[0].keys.map(key => {
          return key.replace('midCap', i18n.t('mid-cap')).replace('largeCap', i18n.t('large-cap')).replace('smallCap', i18n.t('small-cap'))
        }),
        name: personalStrategy.latestAnalysis.benchmarks[0].name,
        color: COLORS.silver
      })
    }

    return personalStrategy !== null && personalStrategy.latestAnalysis !== null && personalStrategy.latestAnalysis.marketCapExposures !== null ? (
      <div className='pscard' onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
        <AnalysisCard idOfCard='market-cap-exposures' topOfAppId='personal-strategy-top-of-app' key='marketcap' chartType='bar' cardTitle={i18n.t('market-cap')} showChartLabels={true} heroTitle={i18n.t('marketcap-exposures-title')} categoryIsDate={false} seriesData={seriesData} showGrid={true} showAxes={true} footnoteText={i18n.t('marketcap-exposures-footnote').replace('[[ASOF]]', formatDate(personalStrategy.latestAnalysis.marketCapExposures[0].date))} showDetailsOnHover={false} seriesColor={COLORS.navy} seriesIsPercentage={true} />
      </div>
    ) : null
  }

  renderBondMaturity() {
    const personalStrategy = this.props.personalStrategy

    // Add Maturity data
    let seriesData = [
      {
        data: personalStrategy.latestAnalysis.maturityExposures[0].values,
        categories: personalStrategy.latestAnalysis.maturityExposures[0].keys,
        name: personalStrategy.name,
        color: COLORS.blue
      }
    ]

    return personalStrategy !== null && personalStrategy.latestAnalysis !== null && personalStrategy.latestAnalysis.maturityExposures !== null ? (
      <div className='pscard' onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
        <AnalysisCard idOfCard='bond-maturity-exposures' topOfAppId='personal-strategy-top-of-app' key='maturity' chartType='bar' cardTitle={i18n.t('bond-maturity')} showChartLabels={true} heroTitle={i18n.t('maturity-exposures-title')} categoryIsDate={false} seriesData={seriesData} showGrid={true} showAxes={true} footnoteText={i18n.t('maturity-exposures-footnote').replace('[[ASOF]]', formatDate(personalStrategy.latestAnalysis.maturityExposures[0].date))} showDetailsOnHover={false} seriesIsPercentage={true} />
      </div>
    ) : null
  }

  renderCreditQuality() {
    const personalStrategy = this.props.personalStrategy

    // Add Credit Quality data
    let seriesData = [
      {
        data: personalStrategy.latestAnalysis.creditQualityExposures[0].values,
        categories: personalStrategy.latestAnalysis.creditQualityExposures[0].keys,
        name: personalStrategy.name,
        color: COLORS.blue
      }
    ]

    return personalStrategy !== null && personalStrategy.latestAnalysis !== null && personalStrategy.latestAnalysis.creditQualityExposures !== null ? (
      <div className='pscard' onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
        <AnalysisCard idOfCard='credit-quality-exposures' topOfAppId='personal-strategy-top-of-app' key='maturity' chartType='bar' showChartLabels={true} cardTitle={i18n.t('credit-quality')} heroTitle={i18n.t('creditquality-exposures-title')} categoryIsDate={false} seriesData={seriesData} showGrid={true} showAxes={true} footnoteText={i18n.t('creditquality-exposures-footnote').replace('[[ASOF]]', formatDate(personalStrategy.latestAnalysis.creditQualityExposures[0].date))} showDetailsOnHover={false} seriesIsPercentage={true} />
      </div>
    ) : null
  }

  renderHoldingsChart() {
    if (!this.props.personalStrategy) {
      return null
    }

    const personalStrategy = this.props.personalStrategy

    // Get the latest holdings
    const holdings = this.props.personalStrategy.holdings[this.props.personalStrategy.holdings.length - 1]

    // Function to filter unique entries in array
    function onlyUnique(value, index, self) {
      return self.indexOf(value) === index
    }

    // Get distinct Asset Classes
    const assetClasses = holdings.assetClasses.filter(onlyUnique)

    // Zip together the relevant data
    const zippedData = zip(holdings.assetClasses, holdings.tickers, holdings.weights)

    let data = []

    // Loop over each asset class and put the data series together
    assetClasses.forEach(function (assetClass) {
      // Find the elements in the given asset class
      let assetClassZip = zippedData.filter(zd => zd[0] === assetClass)

      // Total up the weights
      let sumWeights = assetClassZip
        .map(x => x[2])
        .reduce(function sumofArray(sum, num) {
          return sum + num
        })

      // Build each treenode by asset class with holdings at the child level
      let assetClassData = {
        name: assetClass,
        value: formatPercent(sumWeights, 1, false),
        id: assetClass,
        children: assetClassZip.map(holding => {
          return {
            name: holding[1],
            value: formatPercent(holding[2], 1, false),
            id: assetClass,
            label: {
              show: true,
              formatter: '{b}'
            },
            link: '#fundchar&tickers=' + holding[1],
            target: '_self'
          }
        })
      }

      // Add that asset class to the array
      data.push(assetClassData)
    })

    return (
      <div className='pscard' onMouseEnter={() => this.setCardHovered()} onMouseLeave={() => this.setCardHovered()}>
        <AnalysisCard
          idOfCard='holdings'
          topOfAppId='personal-strategy-top-of-app'
          key='holdings'
          chartType='treemap'
          cardTitle={i18n.t('holdings')}
          showChartLabels={false}
          showLegend={false}
          categoryIsDate={true}
          seriesData={data}
          showGrid={false}
          showAxes={false}
          heroNumber={holdings.tickers.length}
          heroNumberIsPercent={false}
          heroTitle={i18n.t('number-of-holdings')}
          // onChartClick={this.props.openHoldingsEditor}
          showDetailsOnHover={false}
        />
        <ReactTooltip id={'click-to-edit-holdings-tooltip' + personalStrategy.id} type='light' className='tooltip' effect='float'>
          {i18n.t('click-to-edit-holdings-tooltip')}
        </ReactTooltip>
      </div>
    )
  }

  // Create a divider between the cards
  renderDivider() {
    return (
      <div className='divider'>
        <div className='left-side' />
        <div className='right-side' />
      </div>
    )
  }

  render() {
    const keyMetricsChart = this.renderKeyMetrics()
    const performanceChart = this.renderPerformanceChart()
    const incomeChart = this.renderIncomeChart()
    const holdingsChart = this.renderHoldingsChart()
    const sectorChart = this.renderSectorChart()
    const geographyChart = this.renderGeographyChart()
    const marketCapChart = this.renderMarketCapChart()
    const bondMaturityChart = this.renderBondMaturity()
    const creditQualityChart = this.renderCreditQuality()
    const performanceTable = this.renderFundStdPerformance()

    const masonryOptions = {
      // fitWidth: true,
      columnWidth: '.pscard--sizer',
      gutter: '.gutter--sizer',
      itemSelector: '.pscard',
      percentPosition: true,
      horizontalOrder: true
    }
    // const divider = this.renderDivider();

    return (
      <div className='strategy-blend-analysis'>
        <Masonry
          ref={function (c) {
            this.masonry = this.masonry || c.masonry
          }.bind(this)}
          className={'strategy-charts'} // default ''
          elementType={'div'} // default 'div'
          options={masonryOptions}
          disableImagesLoaded={false} // default false
          updateOnEachImageLoad={false} // default false and works only if disableImagesLoaded is false
        >
          <div className='pscard card--is-invisible pscard--sizer'></div>
          <div className='pscard gutter--sizer'></div>
          {keyMetricsChart}
          {holdingsChart}
          {performanceChart}
          {performanceTable}
          {incomeChart}
          {sectorChart}
          {geographyChart}
          {marketCapChart}
          {creditQualityChart}
          {bondMaturityChart}
        </Masonry>
      </div>
    )
  }
}

StrategyAnalysis.propTypes = {
  /**
   * Callback to open the holdings editor
   */
  openHoldingsEditor: PropTypes.func
}

export default connect(null, {})(StrategyAnalysis)
